import * as React from "react"
const SvgOpenFullScreen = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20v-6q0-.424.288-.713A.97.97 0 0 1 4 13q.424 0 .713.287Q5 13.576 5 14v3.6L17.6 5H14a.97.97 0 0 1-.713-.287A.97.97 0 0 1 13 4q0-.424.287-.712A.97.97 0 0 1 14 3h6q.424 0 .712.288Q21 3.575 21 4v6q0 .424-.288.713A.97.97 0 0 1 20 11a.97.97 0 0 1-.712-.287A.97.97 0 0 1 19 10V6.4L6.4 19H10q.424 0 .713.288.287.287.287.712 0 .424-.287.712A.97.97 0 0 1 10 21z" />
  </svg>
)
export default SvgOpenFullScreen
